import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import RedirectLogin from '../LoginRedirect/LoginRedirect';




interface BannerRedirectProps { }
const BannerRedirect: FC<BannerRedirectProps> = () => (
    <div className="BannerRedirect-container">
    <section className="pds-welcomeBanner pds-typography-center pds-welcomeBanner-background-gradient pds-color-font-neutral-white">
    <h2 className="pds-welcomeBanner-header">Ha terminado el tiempo de la sesión</h2>
    <p className="pds-welcomeBanner-message">...</p>
    <div >
      <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled">
          <Link to="/"><h2 className="pds-welcomeBanner-header pds-color-font-neutral-white">Inicio</h2></Link>
        </a>
    </div>
  
</section>
<RedirectLogin></RedirectLogin>
</div>
);

export default BannerRedirect;